$(document).ready(function() {
	"use strict";
	
	var stickyNav = $('.comp-sticky-quote');
	
	if ( stickyNav.length > 0 ) {
		stickyQuote();
	}
	
	function stickyQuote() {
		// Selection variables
		var dismissButton = $(".comp-sticky-quote .dismiss");
		var dismissedText = $(".comp-sticky-quote .dismissed-text");
		var dismissArrow = $(".comp-sticky-quote .arrow");
		var timeOutFunc;

		// Get the offset position of the navbar
		var sticky = $('.comp-banner-quote > .container').height();

		// initialize variables
		var timeOut = false;
		var hidden = true;
		var minimized = false;
		var userExpanded = false;
		var mobile = false;
		var offsetAmount = false;


		// FUNCTIONS
		// Determine if viewport is in a mobile size
		function isMobile() {
			if ( $(".comp-sticky-quote .text").css('display') === 'block' ) {
				mobile = true;
			} else {
				mobile = false;
				minimized = false;
				hidden = true;
			}
		}

		//Display the sticky quote bar
		function displayQuoteBar() {
			stickyNav.addClass("active");
			stickyNav.removeClass("minimized");
			hidden = false;
			minimized = false;
			dismissToggle();
		}

		//Hide the sticky quote bar
		function hideQuoteBar() {
			clearTimeout(timeOutFunc);
			timeOut = true;

			stickyNav.removeClass("active");
			stickyNav.removeClass("minimized");
			hidden = true;
		}

		//Minimize the quote bar
		function minimizeQuoteBar() {
			stickyNav.addClass("minimized");
			stickyNav.removeClass("active");
			minimized = true;
			timeOut = true;
			hidden = false;
			dismissToggle();		
		}

		//Timeout the quote bar on mobile
		function quoteBarTimeout() {
			if (mobile) {
				timeOutFunc = setTimeout(function() {timeOut = true; minimizeQuoteBar();}, 2000);
			}
		}

		function dismissToggle() {
			if (minimized) {
				dismissedText.addClass("display");
				dismissArrow.addClass("down").removeClass("up");
			} else if (!minimized) {
				dismissedText.removeClass("display");
				dismissArrow.addClass("up").removeClass("down");
			}
		}

		// Assess if the sticky quote bar should be displayed
		function stickyNavDisplay() {
			offsetAmount = (window.pageYOffset > sticky);

			if (!mobile) {
				if (offsetAmount && hidden) {
					displayQuoteBar();
				} else if (!offsetAmount && !hidden) {
					hideQuoteBar();
				}
			}

			if (mobile) {
				if (!userExpanded) {
					if (offsetAmount && !timeOut && hidden) {
						displayQuoteBar();
						quoteBarTimeout();
					}

					if (offsetAmount && timeOut) {
						minimizeQuoteBar();
					}

				} else if (userExpanded) {
					if (offsetAmount && hidden) {
						displayQuoteBar();
					} 
				}

				if (!offsetAmount && !hidden) {
					hideQuoteBar();
				}

				if (offsetAmount && hidden && minimized) {
					minimizeQuoteBar();
				}
			}

		}


		//Initial execution on load
		isMobile();

		// When the user scrolls the page, execute a function 
		window.onscroll = function() {stickyNavDisplay();};
		// When the user resizes the page, execute a function
		window.onresize = function() {isMobile();};

		// Function to minimize on mobile when dismiss button clicked
		dismissButton.click(function() {

			if (!minimized) {
				minimizeQuoteBar();
				timeOut = true;
				userExpanded = false;
			} else if (minimized) {
				displayQuoteBar();
				userExpanded = true;
			}

		});

	}
	
	// End of $(document).ready -----------------------------
});